import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';

import { CmnTemplatesModule } from './directives/components/templates/cmn-templates-module';
import { InitializationModule } from './directives/components/views/initialization/initialization.module';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

//import "hammerjs";
import { CookieModule } from 'ngx-cookie';
//error handler
import { LOGGING_ERROR_HANDLER_PROVIDERS } from './directives/components/views/error/errorHandler.component';

import { CacheService } from './services/sys/cache.service';
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {SettingsService} from "./services/sys/settings.service";
import {StaticsService} from "./services/sys/statics.service";
import {LocaleService} from "./services/ui/locale.service";
import {SyntacticSugarService} from "./services/sys/syntactic-sugar.service";
import {WsService} from "./services/sys/ws.service";
import {CmnUiService} from "./services/ui/cmn-ui.service";
import {LinkService} from "./services/ui/link.service";
import {WindowService} from "./services/ui/window.service";
import {PageTitleService} from "./services/ui/page-title.service";
import {CurrencyPipe} from "@angular/common";
import {CurrentModuleService} from "./services/sys/common-module.service";
import {NgModule} from "@angular/core";
import {ApplicationService} from "./services/domain/application.service";
import {QueryManagerService} from "./services/domain/query-manager.service";
import {FilterManagerService} from "./services/ui/filter-manager.service";
import {ModalService} from "./services/ui/modal.service";
import {QueryStringBuilderService} from "./services/domain/query-string-builder.service";
import {CsvManagerService} from "./services/domain/csv-manager.service";

//XXX:ROLLOVER imports for new cycle
@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        CookieModule,
        CookieModule.forRoot(),
        AppRoutingModule,
        CmnTemplatesModule,
        InitializationModule], providers: [
        // LOGGING_ERROR_HANDLER_PROVIDERS,
        CacheService,
        CurrentModuleService,
        CmnUiService,
        CurrencyPipe,
        LinkService,
        LocaleService,
        PageTitleService,
        SettingsService,
        StaticsService,
        SyntacticSugarService,
        WindowService,
        WsService,
        ApplicationService,
        QueryManagerService,
        CsvManagerService,
        FilterManagerService,
        QueryStringBuilderService,
        ModalService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {}
